module.exports = __webpack_public_path__ + "static/media/84.0a604224.jpg";